import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass, NgStyle} from '@angular/common';
import {VehicleBrand} from '../../../../../domain/core/vehicle-brand.model';
import {LegalEntity} from '../../../../../domain/core/legal-entity.model';
import {CustomerWizardResponse} from '../../../../../domain/data/customer-wizard-response.data';
import {WizardType} from '../../wizard-type.enum';
import {Country} from '../../../../../domain/core/country.model';

@Component({
  selector: 'app-wizard-customer-data',
  imports: [
    NgStyle,
    NgClass
  ],
  standalone: true,
  templateUrl: './wizard-customer-data.component.html'
})
export class WizardCustomerDataComponent {
  @Input() customerWizardResponse: CustomerWizardResponse;
  @Input() brand: VehicleBrand;
  @Input() legalEntity: LegalEntity;
  @Output() nextStep = new EventEmitter<void>();

  protected readonly WizardType = WizardType;
  protected readonly Country = Country;

  getVisibleContactLines(data: any): string[] {
    return [
      data.emailPersonal,
      data.emailOffice,
      data.phoneMobile,
      data.phoneHome,
      data.phoneOffice,
    ].filter(Boolean);
  }
}
